/**
 * Application theme configuration
 * YouTube-inspired color scheme: Primary (Red), Secondary (White/Black)
 */

export const colors = {
  primary: {
    name: 'red',
    base: 'red-600',      // YouTube red
    light: 'red-500',     // lighter red
    lighter: 'red-100',   // very soft background tint
    dark: 'red-800',      // deep red
    hover: 'red-700',
    activeText: 'white', // highlight on active
    gradient: 'from-red-600 to-red-500',       // YouTube red gradient
    gradientHover: 'from-red-700 to-red-600',
    contrast: 'white'
  },
  secondary: {
    name: 'white',
    base: 'white',    // accent
    light: 'gray-100',
    hover: 'gray-200',
    text: 'black'      // black text for contrast
  }
};

// Generate CSS variable style object for components that need direct CSS values
export const cssVars = {
  '--color-primary': 'rgb(220, 38, 38)',    // red-600
  '--color-primary-light': 'rgb(239, 68, 68)', // red-500
  '--color-primary-dark': 'rgb(153, 27, 27)',  // red-800
  '--color-primary-contrast': 'white',
  '--color-secondary': 'white',
  '--color-secondary-hover': 'rgb(229, 231, 235)' // gray-200
};

// Function to get color class based on variant
export function getColorClass(variant = 'base', type = 'bg') {
  if (type === 'text') {
    return `text-${colors.primary[variant]}`;
  } else if (type === 'border') {
    return `border-${colors.primary[variant]}`;
  } else if (type === 'gradient' && variant === 'base') {
    return `bg-gradient-to-r ${colors.primary.gradient}`;
  } else if (type === 'gradient' && variant === 'hover') {
    return `bg-gradient-to-r ${colors.primary.gradientHover}`;
  }
  return `${type}-${colors.primary[variant]}`;
}

export default {
  colors,
  cssVars,
  getColorClass
};
